import { CommonService } from './../../../../provide/common.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-reset-service-provider',
    templateUrl: './reset-service-provider.component.html',
    styleUrls: ['./reset-service-provider.component.scss'],
    standalone: false
})
export class ResetServiceProviderComponent implements OnInit {

  resetPassword!: UntypedFormGroup;

  myEmail: any;


  //  for icon 1nd

  visibles: boolean = false;
  changetypes: boolean = true
  serviceRole: string;
  signupTitle: string;
  userType: string;

  viewpas() {
    this.visibles = !this.visibles;
    this.changetypes = !this.changetypes
  }


  visible: boolean = false;
  changetype: boolean = true;

  // myToken: any;

  viewpass() {
    this.visible = !this.visible;
    this.changetype = !this.changetype;

  }



  constructor(private fb: UntypedFormBuilder, http: HttpClient, public commonService: CommonService, private router: Router) { 
    this.serviceRole = localStorage.getItem('serviceRole')
    if(this.serviceRole == "PICKUP"){
      this.signupTitle  = "Signup As Pickup Partner"
      this.userType = "PICKUP_PARTNER"
    }
    else if(this.serviceRole == "DELIVERY"){
      this.signupTitle  = "Signup As delivery Partner"
      this.userType = "DELIVERY_PARTNER"
      
    }
    else if(this.serviceRole == "FIELD"){
      this.signupTitle  = "Signup As field entity"
      this.userType = "FIELD_ENTITY"
    }
    else{
      this.signupTitle  = "Signup As Service Provider"
      this.userType = "SERVICE_PROVIDER"
    }
  }

  ngOnInit(): void {

    this.resetPassword = this.fb.group({
      'password': new UntypedFormControl('', [
        Validators.required,
        // Validators.pattern("(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$")
        // Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}'),
      ]),
      'confirmPassword': new UntypedFormControl('', Validators.required),
    })

    this.myEmail = localStorage.getItem('email')

  }



  navigateToResetPassword() {
    if(this.resetPassword.invalid){
      return this.commonService.errorToast("Please fill all required field.")
    }
    if(this.resetPassword.value.password != this.resetPassword.value.confirmPassword){
      return this.commonService.errorToast("Password and confirm password must be same.")
    }
    let apiReqData = {
      // userType: 'WHOLE_SALER',
      email: this.myEmail,
      newPassword: this.resetPassword.value.password,
      userType: this.userType,

    }
    // var newPassword = { newPassword: this.resetPassword.value.password }
    // var token = localStorage.getItem('verifyOtpToken')
    this.commonService.showSpinner();
    this.commonService.putApi('user/resetPassword', apiReqData, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.commonService.hideSpinner();
        // this.router.navigate(['/change-password'])
        this.router.navigate(['/login-service-provider'])
        // localStorage.removeItem("verifyOtpToken")
        this.commonService.successToast(res.responseMessage);
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    });
  }


  preventSpace(event: any) {
    if ((event.charCode == 32) && !event.target.value) {
      event.preventDefault();
    }
  }

}
